import { useState } from "react";

export default function AccountManagement() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const callApi = async (url, method = "POST", body = {}) => {
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: method !== "DELETE" ? JSON.stringify(body) : undefined,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Something went wrong");
      setMessage("✅ Success");
    } catch (err) {
      setMessage("❌ " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full bg-white shadow-lg rounded-2xl p-6 my-6">
      <h2 className="text-lg font-semibold mb-4">Account Management</h2>

      {message && (
        <p className="mb-4 text-sm font-medium text-center">{message}</p>
      )}

      {/* Update Name */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Update Name
        </label>
        <div className="flex gap-2">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter new name"
            className="flex-1 px-3 py-2 border rounded-lg"
          />
          <button
            onClick={() => callApi("/api/account/updateName", "POST", { name })}
            disabled={loading}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
          >
            Save
          </button>
        </div>
      </div>

      {/* Update Email */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Update Email
        </label>
        <div className="flex gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter new email"
            className="flex-1 px-3 py-2 border rounded-lg"
          />
          <button
            onClick={() =>
              callApi("/api/account/updateEmail", "POST", { email })
            }
            disabled={loading}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
          >
            Save
          </button>
        </div>
      </div>

      {/* Reset Password */}
      <div className="mb-6">
        <h3 className="text-sm font-medium text-gray-700 mb-2">
          Reset Password
        </h3>
        <button
          onClick={() => callApi("/api/account/resetPassword", "POST")}
          disabled={loading}
          className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:opacity-50"
        >
          Send Reset Email
        </button>
      </div>

      {/* Delete Account */}
      <div className="mb-2">
        <h3 className="text-sm font-medium text-gray-700 mb-2">
          Delete Account
        </h3>
        <button
          onClick={() => callApi("/api/account/delete", "DELETE")}
          disabled={loading}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
        >
          Delete Account
        </button>
        <p className="text-xs text-gray-500 mt-2">
          ⚠ This action cannot be undone.
        </p>
      </div>
    </div>
  );
}
